import React, { Component } from "react";
import { DKLabel, DKButton, isEmpty } from "deskera-ui-library";
import DataGridHolder from "../common/DataGridHolder";

import RouteManager from "../../managers/RouteManager";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
  TABLE_DISPLAY_NAME,
} from "../../managers/TableManger";
import AddSegmentPopup from "../common/AddSegmentPopup";
import { showFormPopup } from "../../components/menu/AddNewRecordPopup";
import ContactManager from "../../managers/ContactManager";
import JobPipelineService from "../common/Dashboard/JobPipeline";
import Table from "../../services/table";
import { CONSTANTS } from "../../constants/Constant";
import JobOpeningContainer from "./JobOpeningContainer";
import Utility from "../../utility/Utility";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

export default class List extends Component {
  constructor(props) {
    super(props);
    this.filterColumnId = null;
    this.listContainerRef = React.createRef();
    this.state = {
      currentSegment: -1,
      segmentList: [],
      filter: {},
      needAddSegmentPopup: false,
      showList: false,
      segmentEditValue: null
    };
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    this.getSegmentList();
    this.getPipeline();
  }
  render() {
    return (
      <div
        className="column parent-width flex-1" ref={this.listContainerRef}
      >
        <div className="row ">
          <DKLabel text="All Job Opening" className="fw-m fs-l" />

        </div>
        {this.getSegmentControl()}
        {this.state.showList && (
          <div className="column parent-width mb-s position-relative flex-1 ">
            <DataGridHolder
              tableName={TABLES.CANDIDATE}
              module={MODULE.CANDIDATE}
              displayTableName={TABLE_DISPLAY_NAME["JOBOPENING"]}
              allowRowEdit={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
              allowColumnEdit={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
              allowRowAdd={true}
              allowColumnAdd={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
              allowColumnDelete={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.DELETE])}
              allowColumnShift={true}
              allowSearch={true}
              allowFilter={true}
              filter={this.state.filter}
              onRowEdit={(data) => {
                this.showPopup(data.rowData);
              }}
              refresh={this.state.refresh}
              addButtonConfig={{
                title: "+ New Candidate",
                className: "bg-app text-white ml-s",
                onClick: () => this.showPopup(),
              }}
              contextMenu={true}
              isFromSegmentList = {true}
              onRowOpenClick={(data) => {
                if(PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.VIEW)) {
                  RouteManager.navigateToPage(`/candidate/${data.rowData.id}`)
                }                
              }}
              isSelectOptionShow={true}
            />
          </div>
        )}

        {this.state.needAddSegmentPopup && this.getAddSegmentPopup()}
      </div>
    );
  }
  getSegmentList=()=> {
    let segmentColum = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    if(segmentColum) {
        this.filterColumnId = segmentColum.key;
        this.setState({
        segmentList: [{ name: "All", id: -1 }, ...segmentColum.options].filter(seg=> seg?.type !== "Pipeline"),
        showList: true,
        filter: !Utility.isEmpty(this.state.filter) ? this.state.filter : {} ,
        });
    }

  }
  editSegmentPopup = (id) => {
    let segmentIndex = this.state.segmentList.findIndex(segment => segment.id === id)
    this.setState({ segmentEditValue: this.state.segmentList[segmentIndex] }, () => {
      this.showAddSegmentPopup()
    })
  };   
  getSegmentControl() {
    const listContainer = this.listContainerRef.current;
    return (
      <JobOpeningContainer
        data={this.state.segmentList}
        selectedId={this.state.currentSegment}
        onChange={this.onSegmentSelect}
        onClickEdit={this.editSegmentPopup}
        onClickNew={this.showAddSegmentPopup}
        maxWidth={listContainer?.innerWidth}
        isAddEnabled={PermissionUtils.hasAccess(MODULE.JOB_OPENING, ACTION.CREATE)}
        onDelete={this.onDelete}
      />
    );
  }
  onDelete=()=> {
    this.getPipeline()
    
  }
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  showAddSegmentPopup = () => {
    this.setState({ needAddSegmentPopup: true });
  };
  hideAddSegmentPopup = () => {
    this.setState({ needAddSegmentPopup: false, segmentEditValue: null });
  };
  getAddSegmentPopup() {
    return (
      <AddSegmentPopup
        onCancel={this.hideAddSegmentPopup}
        onSave={this.onAddSegment}
        data={this.state.segmentEditValue}
      />
    );
  }
  onAddSegment = (data, segment) => {
    this.hideAddSegmentPopup();
    
    this.getPipeline()
  };
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  onSegmentSelect = (segment, index) => {
    let filter =
      segment.id !== -1
        ? {
            colId: this.filterColumnId,
            value: segment.id,
            opr: "in",
          }
        : {};
    
    let segmentObj = segment    
    if(segmentObj && segmentObj.type === CONSTANTS.PIPELINE){
      let pipelineId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID)
      filter.colId = pipelineId
    }
        
    this.setState({
      currentSegment: segment.id,
      filter:filter,
    });
  };
  showPopup = (row = {}) => {
    if (isEmpty(row)) {
      const selectedSegIndex = this.state.segmentList.findIndex(
        (seg) => seg.id === this.state.currentSegment
      );
      row[
        TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)
      ] = selectedSegIndex === 0 ? [0] : [selectedSegIndex - 1];
    }
    showFormPopup(
      {
        tableName: TABLES.CANDIDATE,
        recordId: row.id,
        defaultValues: ContactManager.getDefaultValues(row),
        displayName: TABLES.CANDIDATE,
        inputData : JobPipelineService.getPipelineData(JobPipelineService.pipelineData),
        popupClass: 'custom-scroll'
      },
      () => {
        this.setState({ refresh: true });
      }
    );
  };

  getPipeline() {
    const pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    const stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    Table.getRecords(pipelineTableId).then((res) => {
      this.pipeLineData = JobPipelineService.getPipelineData(res);
        JobPipelineService.pipelineData = res;
      this.getAllStages();
    })
  }
  
  getAllStages() {
    const stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    Table.getRecords(stageTableId)
      .then((res) => {
        this.stagesData = JobPipelineService.getStageDataWithPipelineName(res, this.pipeLineData);
        JobPipelineService.stageData = res;
        this.getSegmentList();
      })
      .catch((err) => { });
  } 
}
